


























import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class Importing extends Vue {
  @Prop({})
  importTypes: any[];

  selectedImport = "";

  select(importType: any) {
    this.selectedImport = importType;
    this.$emit("selectevent", importType);
  }
}
